// extracted by mini-css-extract-plugin
module.exports = {"clear-focused":"styles-module__clear-focused___2Fm78","clear":"styles-module__clear___6iN6B"};